<template>
    <div class="auth-container hidden">
        <!-- if user is auth -->
        <template v-if="$store.state.isAuthenticated">
            <button class="auth" @click="logout">
                <CiLogout style="margin-left: 0.2rem;" />
                <span>
                    سجل الخروج
                </span>
            </button>
            <router-link :to="{name:'profile_data'}" class="cart auth">
                <img src="@/assets/profile/cactus.png" alt="">
            </router-link>
            <router-link :to="{name:'cart'}" class="cart auth">
                <img src="@/assets/product/shopping-cart.png" alt="">
            </router-link>
        </template>
        <!-- if user not auth -->
        <template v-else>
            <router-link :to="{name: 'register'}" class="auth register">
                <BxUserPlus />
                انشئ حسابك
            </router-link>
            <router-link :to="{ name: 'login' }" class="auth">
                <img src="../../assets/header icons/watermelon.png" alt="">
                <span>
                    سجل دخولك
                </span>
            </router-link>
        </template>
    </div>
</template>
<script>
import { BxUserPlus, CiLogout } from '@kalimahapps/vue-icons';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';

export default {
    name: 'AuthButtonsComponent',
    components: {
        BxUserPlus,
        CiLogout
    },
    methods: {
        logout() {

            Swal.fire({
                title: "تسجيل الخروج",
                text: "هل انت متاكد من تسجيل الخروج",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "تسجبل خروج" ,
                cancelButtonText: 'الغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('LOGOUT_USER');
                    Cookies.remove('user_token')
                    this.$router.push('/')
                }
            });

        }
    }
}
</script>
<style scoped>
.auth-container {
    display: flex;
    align-items: center;
}

.auth {
    all: unset;
    padding: 0.5rem 1.2rem;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.5s;
    font-weight: bold;
    border: 1px solid #bdc3c7;
}

.auth img {
    width: 30px;
    height: 30px;
    margin-left: 0.5rem;
}

.auth:hover {
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.register {
    margin-left: 1rem;
    background-color: #16C47F;
    color: #fff;
}

.register svg {
    margin-left: 1rem;
    width: 30px;
    height: 30px;
}
.cart {
    width: 35px;
    height: 35px;
    padding: 0.5rem;
    border-radius: 50%;
    margin-right: 1rem;
    text-align: center;
}
.cart img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>